import { gql } from '@apollo/client';

export type GroupQueryResult = {
  group: {
    _id: string;
    name: string;
    isLocked: boolean;
    autolockEnabled: boolean;
    autolockThreshold: number;
  };
};

export const GROUP_QUERY = gql`
  query group($groupId: ID!) {
    group(_id: $groupId) {
      _id
      name
      isLocked
      autolockEnabled
      autolockThreshold
    }
  }
`;

export const GROUP_UPDATE_LOCKED_MUTATION = gql`
  mutation groupUpdateLocked($input: GroupUpdateLockedInput!) {
    groupUpdateLocked(input: $input) {
      league {
        _id
      }
    }
  }
`;

export const GROUP_AUTOLOCK_THRESHOLD_MUTATION = gql`
  mutation groupSetAutolockThreshold($input: GroupSetAutolockThresholdInput!) {
    groupSetAutolockThreshold(input: $input) {
      league {
        _id
      }
    }
  }
`;

export const GROUP_TOGGLE_AUTOLOCK_MUTATION = gql`
  mutation groupSetAutolockEnabled($input: GroupSetAutolockEnabledInput!) {
    groupSetAutolockEnabled(input: $input) {
      league {
        _id
      }
    }
  }
`;
